<table mat-table [dataSource]="dataTable" class="mat-elevation-z8">
    <!-- Date -->
    <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Data</th>
        <td mat-cell *matCellDef="let element"> {{element.date | date: 'dd/MM/yyyy'}} </td>
    </ng-container>

    <!-- Name -->
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Importo</th>
        <td mat-cell *matCellDef="let element"> {{element.name}} {{element.surname}} </td>
    </ng-container>

    <!-- Amount -->
    <ng-container matColumnDef="amount">
        <th mat-header-cell *matHeaderCellDef>Importo</th>
        <td mat-cell *matCellDef="let element"> {{element.amount | currency: 'EUR'}} </td>
    </ng-container>

    <!-- Reason -->
    <ng-container matColumnDef="reason">
        <th mat-header-cell *matHeaderCellDef>Causale</th>
        <td mat-cell *matCellDef="let element"> {{element.reason}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns" style="background-color: #f1f1f1;"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">Nessun dato trovato</td>
    </tr>
</table>